import { omit } from '@/shared/utils/omit';

import { PersonalIdentifierDetails } from '../../sj-orm';
import { QuestionType } from '../../sj-orm/models/form/question.dto';
import { TDtoWrapper } from '../form-wrapper.types';

import {
  commonDetailsFields,
  commonGeneralFields,
  commonLegalizedCopiesFields,
  LegalizedCopiesPartType,
  PersonalIdentifierDetailsFormType,
  PersonalIdentifierGeneralFormType,
} from './commonFields';

export type FreeBlockGeneralFormType = PersonalIdentifierGeneralFormType;

export const FreeBlockGeneralSection: FreeBlockGeneralFormType = {
  ...commonGeneralFields,
};

export type FreeBlockDetailsDto = Omit<PersonalIdentifierDetails, 'createdAt' | 'updatedAt'> & {
  idOfficialName?: string;
};

type FreeBlockDetailsHelp = {
  idOfficialName: QuestionType.TEXT;
};

export type FreeBlockDetailsFormType = Omit<
  PersonalIdentifierDetailsFormType,
  'gender' | 'birthDate' | 'placeOfBirth' | 'issuerCode'
> &
  TDtoWrapper<FreeBlockDetailsDto, FreeBlockDetailsHelp>;

export const FreeBlockDetailsSection: FreeBlockDetailsFormType = {
  idOfficialName: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:taxID.inputs.idOfficialName.label',
    value: '',
    capitalized: true,
    order: 2,
  },
  ...omit(commonDetailsFields, 'gender', 'birthDate', 'placeOfBirth', 'issuerCode'),
};

export const FreeBlockLegalizedCopiesSection: LegalizedCopiesPartType = {
  ...commonLegalizedCopiesFields,
};

export const FreeBlockSections = [
  FreeBlockGeneralSection,
  FreeBlockDetailsSection,
  FreeBlockLegalizedCopiesSection,
];
